"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This hook allows components to use the reducer pattern to manage state that they do not explicitly own
 * (i.e. where they did not have the opportunity to initialize the state using `useReducer`).
 *
 * By passing in a `setState` updater function (which likely came from a custom hook such as `useInlineEditor`)
 * and a `reducer` function, this hook returns a `dispatch` function, like the one returned by `React.useReducer`,
 * which accepts actions and makes the appropriate underlying `setState` calls according to the reducer.
 *
 * For a usage example, see the accompanying unit tests.
 *
 * Implementation note: This is styled as a "hook", but is actually just a function. This is
 * intentional, so that it can also be called from outside a component (e.g. in callbacks).
 *
 * **Note: Unlike the conventional `useReducer`, the returned `dispatch` instance will change if a
 * new reducer is passed in, hence it must be specified in subsequent hooks' dependency arrays.
 * This lack of memoization should be fine for most use cases, but if you need to memoize the dispatch
 * function, you must do it yourself using `React.useMemo`.**
 *
 * For a usage example, see the accompanying unit tests.
 *
 * @param setState The setState handler you have access to
 * @param reducer The reducer representing the state update logic
 */
function useSetStateAsReducer(setState, reducer) {
    return function dispatch(action) {
        setState(function (prevState) { return reducer(prevState, action); });
    };
}
exports.useSetStateAsReducer = useSetStateAsReducer;
//# sourceMappingURL=useSetStateAsReducer.js.map